import { isPlatformBrowser } from '@angular/common';
import { Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

const ICONS_PATH = 'assets/icons/';

const COMMON_LIST = [MatIconModule];

@NgModule({
  imports: COMMON_LIST,
  exports: COMMON_LIST,
  providers: [MatIconRegistry],
})
export class MaterialIconsModule {
  private readonly otherIcons = [
    'places',
    'guides',
    'events',
    'deals',
    'logout',
    'burger-menu',
    'menu-close',
    'chevron-left',
    'card-cvc',
    'qr',
    'search',
    'verified',
    'close',
    'search-placeholder',
    'clear-input',
    'unselect-tag',
    'attention-btn',
    'online-event',
    'arrows-left',
    'featured',
    'checkmark',
    'trash',
    'qr-code',
    'dollar',
    'send',
    'refresh',
    'assistant',
    'my-location',
    'login-secure',
    'chevron',
    'step-done',
    'step-active',
    'step-inactive',
    'arrow-right',
    'location-pin',
    'logo&title',
    'ticket-i',
    'logout-v2',
    'edit-i',
    'empty-search',
    'alert-btn',
    'pin',
    'external',
    'nav-pointer',
    'big-done',
    'box-done',
    'done-star',
    'simple-star',
    'gift',
    'chevron-new',
    'note',
    'done',
    'chevron-right',
    'passports',
    'bt-scanner',
    'bt-email',
    'bt-download',
    'calendar',
    'clock',
  ];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.otherIcons.map((icon: string) => {
      this.matIconRegistry.addSvgIconInNamespace(
        'custom',
        icon,
        this.getIconsUrl(`${icon}.svg`),
      );
    });
  }

  private getIconsUrl(fileName: string): SafeResourceUrl {
    const domain = isPlatformBrowser(this.platformId) ? '' : '/';
    return this.domSanitizer.bypassSecurityTrustResourceUrl(
      domain + ICONS_PATH + fileName,
    );
  }
}
